import * as React from 'react';
import { breakpoints } from '../types/breakpoints';
import { matchMediaSafe } from './matchMediaSafe';

/**
 * Returns true if the viewport is less than breakpoints.md (1024px)
 */
export const useIsNotDesktop = (): boolean => {
	const maxWidth = breakpoints.md - 1;
	const query = React.useRef(matchMediaSafe(`(max-width: ${maxWidth}px)`));
	const [result, setResult] = React.useState(query.current.matches);

	React.useEffect(() => {
		const queryCurrent = query.current;
		const onChange = (event: MediaQueryListEvent): void => {
			setResult(event.matches);
		};
		queryCurrent.addEventListener('change', onChange);
		return () => {
			queryCurrent.removeEventListener('change', onChange);
		};
	}, []);

	return result;
};
